import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonHeader,
  IonIcon,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter
} from "@ionic/react";
import {ListPadding} from "app/employee/incdoc/ListPadding";
import {arrowBackOutline} from "ionicons/icons";
import {useTranslation} from "react-i18next";
import {MenuButton} from "app/employee/menu/MenuButton";
import {linkEmplControlCardInstanceBack} from "app/employee/core/employeeLinks";
import {ControlCardInstance as ControlCardInstancePrintView} from "app/components/print/view/controlcard/ControlCardInstance";
import {InstanceViewActionButton} from "app/employee/controlCard/InstanceViewActionButton";
import {useSafePathParams, zControlCardInstance} from "app/components/hooks/useSafeParams";
import {useEmployeeClientId} from "app/employee/state/bootstrapEmployee/selectors";
import {useMemo} from "react";
import {useQuery} from "app/employee/controlCard/hook/useQuery";
import {
  type ControlCardInstanceIdFragment,
  GetControlCardInstanceTreeDocument,
  type GetControlCardInstanceTreeQuery
} from "app/gql/graphqlSchema";
import {LoadingLoadable} from "app/employee/Loading";
import {isNil} from "app/utils/stdlib";

const stateMapper = (data: GetControlCardInstanceTreeQuery) => data.controlCardInstance;

export const ControlCardViewInstance = () => {
  const {t} = useTranslation();
  const {instanceId} = useSafePathParams(zControlCardInstance);
  const clientId = useEmployeeClientId();
  const controlCardInstanceId = useMemo(
    (): ControlCardInstanceIdFragment => ({instanceId, clientId}),
    [instanceId, clientId]
  );

  const {data, fetch, refetch} = useQuery(GetControlCardInstanceTreeDocument, stateMapper);
  useIonViewWillEnter(() => {
    fetch({id: controlCardInstanceId});
  }, [fetch, controlCardInstanceId]);

  const instance = data.value;
  const backLink = !isNil(instance) ? linkEmplControlCardInstanceBack(instance) : undefined;

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton disabled={isNil(backLink)} fill="clear" routerDirection="back" routerLink={backLink}>
              <IonIcon icon={arrowBackOutline} slot="icon-only" />
            </IonButton>
          </IonButtons>
          <IonTitle>{t("control-card.title", {defaultValue: "Контролни карти"})}</IonTitle>
          <MenuButton />
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonRefresher onIonRefresh={refetch} slot="fixed">
          <IonRefresherContent />
        </IonRefresher>
        <LoadingLoadable loadable={data} />
        {!isNil(instance) && (
          <>
            <IonFab horizontal="end" slot="fixed" vertical="bottom">
              <InstanceViewActionButton instance={instance} />
            </IonFab>
            <ControlCardInstancePrintView instance={instance} />
          </>
        )}
        <ListPadding />
      </IonContent>
    </>
  );
};
